import { render, staticRenderFns } from "./InsuranceCompanyServiceForm.vue?vue&type=template&id=710aa4da&"
import script from "./InsuranceCompanyServiceForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports